import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OrderApprovalRangeDto } from "src/app/features/pages/order/model/order-approval-range.model";

@Injectable({ providedIn: 'root' })
export class OrderApprovalRangeApi {
delayMs: number = 500;

    constructor(
        private _httpClient: HttpClient
    ) {  }

    load(): Observable<OrderApprovalRangeDto> {
        return this._httpClient
            .get<OrderApprovalRangeDto>(`api/order/approval-range/load`, { withCredentials: true })
    }

}